import { useCallback, useRef, useState } from "react";
import 'react-calendar/dist/Calendar.css';
import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import { ReactComponent as CalendarIcon } from "../../../assets/Calendar.svg";
import { WebViewTexts } from "../../../language/Texts";
import { ComponentType } from "../../../models/componentType.enum";
import "./DateComponent.scss";

interface DateComponentProps {
    productionDate: string,
    setProductionDate: (date: string) => void,
    componentType?: ComponentType;
}

function DateComponent({ productionDate, setProductionDate, componentType }: DateComponentProps) {
    // Date process on gemeue
    type ValuePiece = Date | null;
    type Value = ValuePiece | [ValuePiece, ValuePiece];
    const [value, onChange] = useState<Value>(new Date());

    const formatLocalYYYYMMDD = (d: Date) => {
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const setDate = (e: Value) => {
        onChange(e);
        const picked: Date | null = Array.isArray(e) ? (e[0] ?? e[1] ?? null) : (e as Date | null);

        if (!picked) {
            const today = formatLocalYYYYMMDD(new Date());
            setProductionDate(today);
            return;
        }

        const formatted = formatLocalYYYYMMDD(picked);
        setProductionDate(formatted);
    }
    // ****************************

    //  Date process on other user except gemue
    const inputRef = useRef<HTMLInputElement | null>(null);

    const openPicker = useCallback(() => {
        const input = inputRef.current;
        if (!input) return;

        // Preferred modern API (supported in Chromium-based browsers)
        if (typeof (input as any).showPicker === "function") {
            try {
                (input as any).showPicker();
                return;
            } catch (e) {
                console.log('Error on showPicker', e);
            }
        }
        input.focus();
        input.click();
    }, []);

    const onIconKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            openPicker();
        }
    };
    // ***********

    return (
        <>
            {componentType === ComponentType.GEMUE_EXTERNAL ? <div
                className={`input_pair gemue_input_pair`}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px' }}
            >
                <label
                    className={`input_label gemue_input_label`}
                >{WebViewTexts.manufacturerDate}</label>
                <div style={{ display: 'flex', alignItems: 'center', position: 'relative', width: '100%' }}>
                    <DatePicker
                        clearIcon={null}
                        calendarIcon={<CalendarIcon width={24} height={24} />}
                        value={value}
                        onChange={(e) => setDate(e)}
                    />
                </div>
            </div> : <div
                className={`input_pair `}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px' }}
            >
                <label
                    className={`input_label `}
                    style={{ marginBottom: '4px', whiteSpace: 'nowrap' }}
                >{WebViewTexts.manufacturerDate}</label>
                <div style={{ display: 'flex', alignItems: 'center', position: 'relative', width: '100%' }}>
                    <input
                        data-testid='production_date'
                        type="date"
                        className={`input_field custom-date-input`}
                        value={productionDate}
                        onChange={e => setProductionDate(e.target.value)}
                        ref={inputRef}
                    />
                    <span
                        className="calendar_icon"
                        role="button"
                        tabIndex={-1}
                        aria-label="Open date picker"
                        onClick={openPicker}
                        onKeyDown={onIconKeyDown}>
                        <CalendarIcon width={24} height={24} />
                    </span>
                </div>
            </div>}
        </>
    )
}

export default DateComponent